import axios from 'src/store/vue-axios/index.js'
import * as Sentry from '@sentry/vue'
import {defaultState} from '@/store/state.ts'
import {KeycloakAuth} from '@/config/auth/KeycloakAuth.ts'

export default {
  RESET_STATE (state) {
    Object.assign(state, defaultState())
  },
  SET_TRANSITION_NAME (state, transitionName) {
    state.transitionName = transitionName
  },
  SET_HEADER_DISABLED (state, bool) {
    state.headerDisabled = bool
  },

  SET_SLINK (state, object) {
    state.slink = object
  },
  async SET_SCHOOL (state, object) {
    state.school = object

    // Adding slink to sentry:
    Sentry.getCurrentScope().setTag('slink', object.slink)

    // Init keycloak realm, which is connected to the school object and might change whenever the school changes
    const isKeycloakSSOEnabled = object?.meta?.group_iam?.length > 0

    if (!isKeycloakSSOEnabled) return
    const realm = object?.meta?.group_iam?.[0]?.realm_id

    if (!realm) return
    // Create/recreate the KeycloakAuth instance with new redirect URI based on the school object
    await KeycloakAuth.getInstance(realm)

  },
  SET_STAY_LOGGED_IN (state, stayLoggedIn) {
    state.stayLoggedIn = stayLoggedIn
  },
  SET_AUTH_TOKEN (state, { authToken, stayLoggedIn }) {
    state.authToken = authToken

    // set login token globally
    axios.defaults.headers.Authorization = `Bearer ${authToken}`

    // TODO check if functions are available
    if (stayLoggedIn === false) {
      return window.sessionStorage?.setItem('auth_token', authToken)
    }
    return localStorage?.setItem('auth_token', authToken)
  },

  SET_USER_UUID (state, userUuid) {
    localStorage?.setItem('user_uuid', userUuid)
  },

  SET_IS_SCREEN_READER_ACTIVE (state, bool) {
    state.isScreenReaderActive = bool
  },

  SET_IS_KEYBOARD_NAVIGATION_ACTIVE (state, bool) {
    state.isKeyboardNavigationActive = bool
  },

  SET_SOFT_KEYBOARD_HEIGHT (state, number) {
    state.softKeyboardHeight = number
  },

  SET_IS_NATIVE (state, bool) {
    state.isNative = bool
  },

  SET_IS_ANDROID (state, bool) {
    state.isAndroid = bool
  },

  SET_IS_IOS (state, bool) {
    state.isIOS = bool
  }
}
